// src/lib/auth.ts
import { decodeBase64urlToString } from "./base64url";

export const TOKEN_KEY = "admin_token";

export function setToken(t: string) {
  localStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

function parseJwt<T = Record<string, unknown>>(token: string | null | undefined): T | null {
  try {
    const t = (token ?? "").toString();
    const parts = t.split(".");
    if (parts.length < 2 || !parts[1]) return null;

    const jsonStr = decodeBase64urlToString(parts[1]);
    if (!jsonStr) return null;

    // decodeURIComponent(escape(...)) is legacy; if you need UTF-8:
    // return JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(b64), c => c.charCodeAt(0))));
    return JSON.parse(decodeURIComponent(escape(jsonStr)));
  } catch {
    return null;
  }
}

export function isTokenValid(token: string | null): boolean {
  const payload = parseJwt<{ exp?: number }>(token);
  if (!payload?.exp) return false;
  const nowSec = Math.floor(Date.now() / 1000);
  return payload.exp > nowSec + 5;
}
